'use strict'

export const ICONS = {}
